"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleModeDown = void 0;
var toggleModeDown = function (utils) {
    var a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, loadPrimaryInput = utils.loadPrimaryInput, use = utils.use;
    describe('Mode - DOWN toggle', function () {
        it('DOWN Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.downArrow)
                .should('have.value', '08:30 AM')
                .then(a11yHasExpectedHtml("<p>AM.</p>"))
                .then(hasReturnVal('08:30'));
        });
        it('DOWN DOWN Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.downArrow)
                .then(use.downArrow)
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml("<p>PM.</p>"))
                .then(hasReturnVal('20:30'));
        });
        it('DOWN UP Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.downArrow)
                .then(use.upArrow)
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml("<p>PM.</p>"))
                .then(hasReturnVal('20:30'));
        });
    });
};
exports.toggleModeDown = toggleModeDown;
